import { Link } from 'react-router-dom';
import { posts } from '@/mocks/community';

const hotList = posts.slice(0, 4);

export default function HotTopics() {
  const featured = hotList[0];
  const rest = hotList.slice(1);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-end justify-between gap-4">
        <div>
          <span className="text-xs font-semibold tracking-widest text-primary-600">HOT TOPICS</span>
          <h2 className="mt-1 font-heading text-2xl md:text-3xl">热门话题热聊中</h2>
        </div>
        <Link
          to="/community"
          className="inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
        <Link
          to={`/post/${featured.id}`}
          className="group relative flex min-h-[300px] lg:col-span-3 flex-col justify-end overflow-hidden rounded-2xl p-6"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20pirates%20ship%20sailing%20toward%20a%20grand%20adventure%20on%20a%20sunset%20sea%2C%20warm%20coral%20and%20amber%20toned%20sky%2C%20dynamic%20waves%20and%20billowing%20sails%2C%20flat%20vibrant%20anime%20art%20style%2C%20epic%20and%20hopeful%20mood%2C%20clean%20composition%20with%20soft%20glow%20and%20sparkling%20sea%20reflections&width=1200&height=760&seq=hot-featured&orientation=landscape"
            alt={featured.title}
            className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent"></div>
          <div className="relative z-10">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-accent-500 px-3 py-0.5 text-xs font-semibold text-background-50">
                <i className="ri-fire-fill mr-1"></i>今日热议
              </span>
              {featured.tags.slice(0, 2).map((t) => (
                <span key={t} className="rounded-full bg-background-50/20 px-3 py-0.5 text-xs text-background-50 backdrop-blur-sm">
                  {t}
                </span>
              ))}
            </div>
            <h3 className="mt-3 text-lg md:text-2xl font-bold text-background-50 leading-snug">{featured.title}</h3>
            <p className="mt-2 hidden sm:block text-sm text-background-100/85 line-clamp-2">{featured.excerpt}</p>
            <div className="mt-3 flex items-center gap-4 text-xs text-background-100/80">
              <span><i className="ri-eye-line mr-1"></i>{featured.views.toLocaleString()}</span>
              <span><i className="ri-chat-3-line mr-1"></i>{featured.replies} 回复</span>
            </div>
          </div>
        </Link>

        <div className="lg:col-span-2 flex flex-col gap-4">
          {rest.map((p, idx) => (
            <Link
              key={p.id}
              to={`/post/${p.id}`}
              className="flex flex-1 items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 hover:border-primary-300 hover:bg-background-100 transition-colors"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 font-heading text-lg text-primary-700">
                {idx + 2}
              </span>
              <div className="min-w-0">
                <h4 className="truncate text-sm md:text-base font-semibold text-foreground-950">{p.title}</h4>
                <p className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="text-primary-600">{p.board}</span>
                  <span><i className="ri-chat-3-line mr-0.5"></i>{p.replies}</span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}